var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-prewrap max-1-lines"},[_vm._v(_vm._s(_vm.truncatedMessage || "メッセージなし"))])}
var staticRenderFns = []

export { render, staticRenderFns }